<div class="p-grid">
  <div class="p-col header-info">
    <div class="p-grid">
      <div class="p-col-3">
        <span class="property-search-label">Import Date</span> <br />
        <span class="property-search-values">{{property?.CreateDate | dateTimeFormat}}</span>
      </div>
      <div class="p-col-3">
        <span class="property-search-label">Close Date</span><br />
        <span class="property-search-values">{{property?.CloseDate | dateTimeFormat}}</span>
      </div> 
      <div class="p-col-3">
        <span class="property-search-label">Occupancy</span><br />
        <span class="property-search-values">{{property?.Occupancy}}</span>
      </div>
      <div class="p-col-3">
        <span class="property-search-label">Asset Manager</span><br />
        <span class="property-search-values">{{assetManager}}</span>
      </div>
    </div>
  </div>
</div>  